<div class="dsg-icons">
  <div class="dsg-icons-search">
    <mat-icon aria-hidden="true">search</mat-icon>
    <input
      type="text"
      placeholder="Search icons"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      aria-label="Search icons"
    />
    <button
      *ngIf="search()"
      type="button"
      class="dsg-icons-search-clear"
      (click)="search.set('')"
      aria-label="Clear search"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dsg-icons-scroll">
    <p class="dsg-icons-empty" *ngIf="isEmpty()">No icons match that search.</p>

    <section class="dsg-icons-group" *ngFor="let group of groups(); trackBy: trackByGroup">
      <h4 class="dsg-icons-group-title">{{ group.label }}</h4>

      <div class="dsg-icons-grid">
        <button
          *ngFor="let entry of group.entries; trackBy: trackByName"
          type="button"
          class="dsg-icon-tile"
          [class.is-active]="isActive(entry)"
          draggable="true"
          [matTooltip]="entry.label"
          matTooltipShowDelay="300"
          (dragstart)="onDragStart(entry, $event)"
          (click)="onPick(entry)"
          [attr.aria-label]="entry.label"
        >
          <!-- Rendered live, so the tile shows the real glyph rather than a
               bitmap preview that could drift from what gets inserted. -->
          <lucide-angular [img]="$any(entry.data)" [size]="20" [strokeWidth]="1.75"></lucide-angular>
        </button>
      </div>
    </section>
  </div>

  <p class="dsg-icons-hint">
    {{ total() }} icons · drag onto the canvas, or click to apply to the selected icon.
  </p>
</div>
